import { Component, Prop, Vue } from 'vue-property-decorator';
import ChatWindow from 'vue-advanced-chat';
import ChatModule from '@/store/modules/chat-module';
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import {  itiSignalRService, i18n } from '@/iti-core-vue';
import { Room } from '@/shared/dtos/room';
import { Message } from '@/shared/dtos/message';
import { defaultThemeStyles } from'@/shared/themes/chat.ts' ;
import '@/../public/assets/css/main.css';
import { Route } from 'vue-router';
import listaNotificacionesModule from '@/store/modules/listaNotificaciones.module';
import NotificationCounterModule from '@/store/modules/contadorNotificaciones.module';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';

@Component({
    components: {
        ChatWindow
    },
})
export default class ChatUnaSala extends Vue {
    @Prop() public ambitId!: number;
    public roomId!: number;
    public get rooms() : Room[]{
      return ChatModule.rooms;
    }
    public set rooms(rooms: Room[]){
      ChatModule.context.commit("setRooms", rooms);
    }
    public get messages(): Message[]{
      return ChatModule.messages;
    }
    public roomsLoaded: boolean = false;
    public loadingRooms: boolean = false;
    public get messagesLoaded(){
        return ChatModule.messagesLoaded;
    }
    public get currentUserId() {
        return ChatModule.myId;
    }
    
    public get styles(){
        return defaultThemeStyles;
    }

    currentRoomId: number = -1;
    
    public get textMessages() {
        return {
            ROOMS_EMPTY: i18n.tc('chat.ROOMS_EMPTY'),
            ROOM_EMPTY: i18n.tc('chat.ROOM_EMPTY'),
            NEW_MESSAGES: i18n.tc('chat.NEW_MESSAGES'),
            MESSAGE_DELETED: i18n.tc('chat.MESSAGE_DELETED'),
            MESSAGES_EMPTY: i18n.tc('chat.MESSAGES_EMPTY'),
            CONVERSATION_STARTED: i18n.tc('chat.CONVERSATION_STARTED'),
            TYPE_MESSAGE: i18n.tc('chat.TYPE_MESSAGE'),
            SEARCH: i18n.tc('chat.SEARCH'),
            IS_ONLINE: i18n.tc('chat.IS_ONLINE'),
            LAST_SEEN: i18n.tc('chat.LAST_SEEN'),
            IS_TYPING: i18n.tc('chat.IS_TYPING')
        }
      }

    //Disable uploading messages if ambit is inactive
    public isActive(): boolean {
        if(!this.rooms[0]) return false;
        return this.rooms[0].state >= 0;
    }

    public get inactive(): boolean {
        return !this.isActive();
    }
    
    public async created() {
        await ChatModule.fetchId().then(() => {
            ChatModule.loadRoomId(this.ambitId).then((id) => {
                this.roomId = id;
                this.cargarSala();
                itiSignalRService.listenFor('receiveMessage',this.handleMessage);
                itiSignalRService.listenFor('messageRead',this.handleMessageRead);
                this.marcarNotificacionesSalaLeido();
            });
        });
        collaborativeAreaModule.getCollaborativeAreaById(this.ambitId);
    }

    async marcarNotificacionesSalaLeido(){
        await listaNotificacionesModule.cargarNotificaciones();
        listaNotificacionesModule.notificaciones.forEach((value, index, array) => {
                if(!value.isRead && value.idEventSource === (this.ambitId+'')){
                    listaNotificacionesModule.markNotificationAsRead(value.id);
                    value.isRead = true;
                    NotificationCounterModule.decrementCounter();
                }
        })
    }

    public destroyed(){
        itiSignalRService.unListenFor('receiveMessage');
        itiSignalRService.unListenFor('messageRead');
    }
    public async handleMessageRead(idMensaje: number){
        await ChatModule.messageRead(idMensaje);
    }
    public async cargarSala(){
        this.loadingRooms = true;
        this.roomsLoaded = false;
                
        await ChatModule.loadRoom(this.roomId).then((resultadoOk: boolean) => {      
            if(resultadoOk){
                this.roomsLoaded = true;
                this.loadingRooms = false;
            }   
            else{
                this.loadingRooms = false;
            }   
        });
        
    }
    public async handleMessage(mensaje: Message, roomId: number){
      const currentRoomId = this.currentRoomId;
        await ChatModule.receiveMessage( { mensaje, currentRoomId, roomId} );
    }

    public async fetchMessages({ room, options } : {room:any, options:any}) {
        //Called every time a user enters a room or when the user scrolls up inside the chat to load more messages
        //options.reset is true when the room is opened for the first time        
        this.currentRoomId = room.id
        //cargar mensajes de sala
        if(options && options.reset){
            await ChatModule.fetchInitialRoomMessages(room.id);
        }
        else{
            await ChatModule.fetchMoreRoomMessages(room.id);
        }
    } 
    public sendMessage ({ roomId, content, file, replyMessage } : {roomId:any, content:any, file:any, replyMessage:any}) { 
        //Called every time a user presses enter while writing or clicks on the send icon
        //Send message to server, server will return the new message to us and every other user in the room
        if(this.isActive()){
            ChatModule.sendMessage({content, roomId});
        }
    } 

    public fetchMoreRooms() {
        this.loadingRooms = true;
        this.roomsLoaded = false;
        //Load more rooms. Currently we don't use pagination for rooms so this method is useless, but is called by the component
        this.roomsLoaded = true;
        this.loadingRooms = false;
    }

    public backToHome() {
        this.$router.back();
    }

    public goToAreaHome() {
        this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: this.collaborativeArea.id.toString() } });
    }

    public get collaborativeArea() {
        return collaborativeAreaModule.selectedCollaborativeArea;
    }

    public get height() {
        var height = window.innerHeight - 220;
        return "height:" + height.toString() + 'px;';
    }
}
